export class Notification {
    message;
    devices;
    groups;
    statuses;
    roles;
    // the name property is optional and is only for specific notifications which must be associated with a
    // particular node. Only one direct message per status type per node is supported
    names;

    constructor(message, devices, groups, statuses, roles, names = null) {
        this.message = message;
        this.devices = devices;
        this.groups = groups;
        this.statuses = statuses;
        this.roles = roles;
        this.names = names;
    }

    getMessage() {
        return this.message;
    }

    getDevices() {
        return this.devices;
    }

    getGroups() {
        return this.groups;
    }

    getStatuses() {
        return this.statuses;
    }

    getRoles() {
        return this.roles;
    }

    getNames() {
        return this.names;
    }

    toJSON() {
        return {
            message: this.message,
            devices: this.devices,
            groups: this.groups,
            statuses: this.statuses,
            roles: this.roles,
            names: this.names
        };
    }

    static jsonDeserialize(jsonString) {
        let data = jsonString;
        return new Notification(
            data.message,
            data.devices,
            data.groups,
            data.statuses,
            data.roles,
            data.names
        );
    }
}